import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { DateRange } from 'react-date-range';

import CALENDAR_THEME from 'components/lib/date/calendar_theme';

// The range paints a white panel of its own around the two calendars. The stylesheet hides the
// arrows between them, which only works once the inline display is gone.
const DATE_RANGE_THEME = {
  ...CALENDAR_THEME,
  DateRange: {
    background: null,
  },
  MonthArrow: {
    ...CALENDAR_THEME.MonthArrow,
    display: null,
  },
};

const DateRangeWrapper = ({ startDate, endDate, onChange }) => {
  return (
    <DateRange
      endDate={moment(endDate)}
      linkedCalendars
      onChange={onChange}
      startDate={moment(startDate)}
      theme={DATE_RANGE_THEME}
    />
  );
};

DateRangeWrapper.propTypes = {
  startDate: PropTypes.any.isRequired,
  endDate: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired, // onChange({ startDate, endDate })
};

export default DateRangeWrapper;
